import React, { useState } from "react";
import {
  Typography,
  TextField,
  Button,
  Grid,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material"; // Adjust path as needed
import LabelledBox from "../../../../../../../../../components/widgets/LabelledBox";
import { secondAxios } from "../../../../../../../../../api/axios";
import { useParams } from "react-router-dom";

export default function COForm({
  setShowCOForm,
  setSubmitSuccess,
  selectedCOMaterials,
}) {
  const { plantId } = useParams();
  // Field configuration array (single source of truth for form structure)
  const FORM_FIELDS = [
    {
      name: "coNumber",
      label: "CO Number",
      type: "text",
      gridProps: { xs: 4 },
      fieldProps: {
        size: "small",
        fullWidth: true,
        // sx: { width: "220px" },
        required: true,
      },
    },
    {
      name: "date",
      label: "Date",
      type: "date",
      gridProps: { xs: 4 },
      fieldProps: {
        size: "small",
        fullWidth: true,
        // sx: { width: "220px" },
        InputLabelProps: { shrink: true },
        required: true,
      },
    },
    {
      name: "responsible",
      label: "Responsible",
      type: "text",
      gridProps: { xs: 4 },
      fieldProps: {
        size: "small",
        fullWidth: true,
        // sx: { width: "220px" },
        required: true,
      },
    },
    {
      name: "description",
      label: "Scope Description",
      type: "textarea",
      gridProps: { xs: 12, sx: { mt: 2 } },
      fieldProps: {
        multiline: true,
        rows: 3,
        size: "small",
        sx: { width: "100%" },
        required: true,
      },
    },
  ];

  // Initialize form state from field configuration
  const initialState = Object.fromEntries(
    FORM_FIELDS.map((field) => [
      field.name,
      field.type === "date" ? getTodayDate() : "",
    ]),
  );

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  // Helper: Get today's date in YYYY-MM-DD format for date field
  function getTodayDate() {
    const today = new Date();
    return today.toISOString().split("T")[0];
  }

  // Handle all input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: null })); // Clear error on change
    setSubmitError(null);
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    FORM_FIELDS.forEach((field) => {
      if (field.fieldProps?.required && !formData[field.name]?.trim()) {
        newErrors[field.name] = `${field.label} is required`;
        isValid = false;
      }

      // Special validation for date field
      if (field.name === "date" && formData[field.name]) {
        const selectedDate = new Date(formData[field.name]);
        if (isNaN(selectedDate) || selectedDate > new Date()) {
          newErrors.date = "Date cannot be in the future";
          isValid = false;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  // Handle confirm submission
  const onConfirm = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);
    setSubmitError(null);

    console.log({
      plantId,
      ...formData,
      // materials: selectedCOMaterials,
    });
    try {
      const response = await secondAxios.post("/change-order", {
        plantId,
        ...formData,
        materials: selectedCOMaterials,
      });
      console.log("response of co", response);
      if (!response?.data?.id) {
        // Handle specific error responses
        // const errorData = await response.data.catch(() => ({}));
        throw new Error(
          //   errorData.message ||
          `Submission failed: ${response.status}`,
        );
      }

      // Success handling
      const result = await response.data;
      console.log("CO created successfully:", result);

      // Close form and reset parent state
      setShowCOForm(false);

      setSubmitSuccess(true);
    } catch (error) {
      console.error("API submission error:", error);
      setSubmitError(
        error.message || "Failed to submit Change Order. Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <LabelledBox label="CO Details" sx={{ m: "auto", mt: 2 }}>
        <Grid container sx={{ width: "1050px" }}>
          {FORM_FIELDS.map((field) => (
            <Grid item {...field.gridProps} key={field.name}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ pl: 2, minWidth: "100px" }}
                >
                  {field.label}
                </Typography>
                <TextField
                  name={field.name}
                  value={formData[field.name]}
                  onChange={handleChange}
                  error={!!errors[field.name]}
                  helperText={errors[field.name]}
                  {...(field.type === "textarea" ? {} : { type: field.type })}
                  {...field.fieldProps}
                />
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Error alert for submission errors */}
        {submitError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {submitError}
          </Alert>
        )}

        <Box sx={{ textAlign: "right", mt: 2 }}>
          <Button
            color="error"
            sx={{ mx: 1 }}
            onClick={() => setShowCOForm(false)}
            disabled={isSubmitting}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            disabled={isSubmitting}
            startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
          >
            {isSubmitting ? "Submitting..." : "Confirm"}
          </Button>
        </Box>
      </LabelledBox>
    </div>
  );
}
